<crm-single-select
  [options]="filials"
  [(selectedItem)]="selectedFilial"
  (selectedItemChange)="selectedFilialChange.emit($event)"
  (changeValue)="changeValue.emit($event)"
  [showClear]="showClear"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled">
</crm-single-select>
